import { RootState } from '../store';

export const appInfoSelector = (state: RootState) => state.appInfo.app;

export const appErrorSelector = (state: RootState) => state.appInfo.error;

export const locationSelector = (state: RootState) =>
  state.appInfo.currentLocation;
